import { render, staticRenderFns } from "./ExpressAdmin.vue?vue&type=template&id=315fa612&scoped=true"
import script from "./ExpressAdmin.vue?vue&type=script&lang=js"
export * from "./ExpressAdmin.vue?vue&type=script&lang=js"
import style0 from "./ExpressAdmin.vue?vue&type=style&index=0&id=315fa612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315fa612",
  null
  
)

export default component.exports